// src/components/ImageCarousel.jsx
import React, { useState } from 'react';

const ImageCarousel = ({ images }) => {
  const [index, setIndex] = useState(0);

  if (!images || images.length === 0) return <div className="carousel-container" style={{background: '#1e293b'}}></div>;

  const next = () => setIndex((index + 1) % images.length);
  const prev = () => setIndex((index - 1 + images.length) % images.length);

  return (
    <div className="carousel-container">
      <img src={images[index]} alt="Project" className="carousel-img" />
      {images.length > 1 && (
        <>
          <button className="nav-btn" style={{left: '10px'}} onClick={prev}>‹</button>
          <button className="nav-btn" style={{right: '10px'}} onClick={next}>›</button>
        </>
      )}
    </div>
  );
};

export default ImageCarousel;